import { V2_PERMISSION_API_KEY_MAP } from './consts';
export var transformForV2Permission = function transformForV2Permission() {
  var rowData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var result = {};
  Object.keys(rowData).forEach(function (dataKey) {
    var needTransformKey = V2_PERMISSION_API_KEY_MAP[dataKey];
    if (needTransformKey) {
      result[needTransformKey] = rowData[dataKey];
    } else {
      result[dataKey] = rowData[dataKey];
    }
  });
  return result;
};